import React, { useEffect, useState } from "react";
import styles from "./AttendeesDetails.module.css";
import {
  Box,
  DropDown,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import { MdCall, MdChat } from "react-icons/md";
import { LocIcon, UserIcon } from "../../../../../components/icons/Icons";
import { List } from "antd";
import { HiOutlineUser } from "react-icons/hi2";
import { GoDotFill } from "react-icons/go";
import Modal from "../../../../../components/modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";
import { useLocation, useNavigate } from "react-router-dom";
import { EventPlanningMiddleware } from "../../../../../Store/Middlewares/EventPlanningMiddleware";

const TableIcon = () => {
  return (
    <svg
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.svgIcon}
    >
      <path
        d="M13.607 22.0022C12.2038 22.0022 10.8001 22.0022 9.39691 22.0022C9.37916 21.9914 9.36248 21.9748 9.34311 21.9705C8.17075 21.7025 7.55632 20.7524 7.80273 19.5811C7.90281 19.1065 8.00988 18.6331 8.12071 18.1295C6.86011 18.1295 5.61995 18.1295 4.35935 18.1295C4.35935 16.8694 4.35935 15.6363 4.35935 14.388C3.85522 14.4989 3.37476 14.6065 2.89322 14.7092C1.62993 14.9788 0.51352 14.0943 0.505449 12.8078C0.497917 11.6053 0.498455 10.4023 0.505449 9.19981C0.512982 7.91016 1.62455 7.0251 2.88838 7.29411C3.37583 7.39795 3.86221 7.50717 4.37226 7.61908C4.37226 6.36117 4.37226 5.12532 4.37226 3.87117C5.62695 3.87117 6.86226 3.87117 8.12017 3.87117C8.0045 3.34713 7.88774 2.8473 7.7839 2.34479C7.53802 1.15036 8.40909 0.0253429 9.61535 0.00758791C10.8749 -0.0107051 12.1349 -0.00102055 13.3945 0.00597382C13.8303 0.00866397 14.2252 0.158774 14.5561 0.442853C15.2028 0.998637 15.3803 1.70184 15.1861 2.51803C15.0812 2.96029 14.987 3.4047 14.8821 3.87333C16.1465 3.87333 17.3813 3.87333 18.6354 3.87333C18.6354 5.12855 18.6354 6.36386 18.6354 7.61854C19.1525 7.50448 19.6464 7.3915 20.1419 7.28658C21.0318 7.09827 21.9018 7.51094 22.2951 8.31583C22.3844 8.49876 22.4328 8.70213 22.5001 8.89636C22.5001 10.3001 22.5001 11.7038 22.5001 13.1075C22.4861 13.1468 22.4683 13.185 22.4586 13.2248C22.2725 13.9953 21.7979 14.4865 21.035 14.7017C20.6041 14.8233 20.186 14.7345 19.7663 14.6366C19.3956 14.5505 19.0233 14.4714 18.6252 14.3837C18.6252 15.6535 18.6252 16.8877 18.6252 18.1402C17.371 18.1402 16.1373 18.1402 14.8853 18.1402C14.9994 18.6562 15.1124 19.1501 15.2168 19.6451C15.4045 20.5334 14.9913 21.4039 14.187 21.7967C14.0041 21.8865 13.8007 21.935 13.607 22.0022ZM10.8496 1.29455C10.4267 1.29455 10.0264 1.28164 9.62773 1.29832C9.26671 1.31338 8.9794 1.63028 9.04074 1.97946C9.15104 2.61057 9.30114 3.23522 9.4335 3.85611C9.92042 3.85611 10.3815 3.85611 10.8501 3.85611C10.8496 3.00064 10.8496 2.15917 10.8496 1.29455ZM21.2056 10.3533C21.2056 9.92238 21.2239 9.5081 21.2002 9.09651C21.1792 8.73872 20.8521 8.49553 20.4921 8.54019C20.3157 8.56225 20.1413 8.60475 19.967 8.64349C19.5237 8.74195 19.0809 8.8431 18.651 8.93994C18.651 9.42794 18.651 9.88903 18.651 10.3533C19.5038 10.3533 20.3399 10.3533 21.2056 10.3533ZM13.5683 3.86203C13.7011 3.24491 13.8443 2.63317 13.9605 2.01605C14.0229 1.68301 13.8055 1.34997 13.4757 1.3193C13.0399 1.27895 12.5976 1.30962 12.164 1.30962C12.164 2.16831 12.164 3.01517 12.164 3.86203C12.6375 3.86203 13.0942 3.86203 13.5683 3.86203ZM4.36365 8.9351C3.74115 8.80167 3.12404 8.65479 2.49992 8.54234C2.17065 8.48316 1.84084 8.72043 1.81447 9.04647C1.7795 9.4769 1.80587 9.91162 1.80587 10.3415C2.66779 10.3415 3.51411 10.3415 4.36365 10.3415C4.36365 9.86912 4.36365 9.41233 4.36365 8.9351ZM1.79672 11.657C1.79672 12.0772 1.78112 12.4839 1.80156 12.8891C1.81985 13.2571 2.14805 13.5143 2.51553 13.4621C2.77647 13.425 3.03365 13.3598 3.2919 13.3034C3.6513 13.2243 4.00963 13.1414 4.36043 13.0623C4.36043 12.5781 4.36043 12.1229 4.36043 11.657C3.50819 11.657 2.66671 11.657 1.79672 11.657ZM21.2083 11.6618C20.3383 11.6618 19.4919 11.6618 18.6402 11.6618C18.6402 12.1331 18.6402 12.5899 18.6402 13.0699C19.2681 13.2038 19.8922 13.3539 20.5234 13.4642C20.8709 13.525 21.1889 13.2372 21.2045 12.8767C21.2212 12.4775 21.2083 12.0772 21.2083 11.6618ZM10.8426 20.7099C10.8426 19.8399 10.8426 18.9936 10.8426 18.1413C10.3713 18.1413 9.91504 18.1413 9.44157 18.1413C9.31836 18.6928 9.19462 19.2416 9.07302 19.7914C9.0558 19.8678 9.04074 19.9459 9.03482 20.0239C9.00846 20.3779 9.26725 20.691 9.62773 20.7061C10.0269 20.7228 10.4272 20.7099 10.8426 20.7099ZM12.1554 20.7109C12.5724 20.7109 12.9657 20.7212 13.3579 20.7077C13.7205 20.6953 14.0229 20.3876 13.9648 20.0432C13.8572 19.4051 13.7038 18.7746 13.5715 18.1494C13.0813 18.1494 12.6197 18.1494 12.1554 18.1494C12.1554 19.0054 12.1554 19.8474 12.1554 20.7109Z"
        className={styles.svgIconPath}
      />
    </svg>
    //   <svg
    //     viewBox="0 0 23 22"
    //     fill="none"
    //     xmlns="http://www.w3.org/2000/svg"
    //     className={styles.svgIcon}
    //   >
    //     <path
    //       d="M13.607 22.0051C12.2038 22.0051 10.8001 22.0051 9.39691 22.0051C9.37916 21.9944 9.36248 21.9777 9.34311 21.9734C8.17075 21.7055 7.55632 20.7553 7.80273 19.584C7.90281 19.1095 8.00988 18.636 8.12071 18.1324C6.86011 18.1324 5.61995 18.1324 4.35935 18.1324C4.35935 16.8723 4.35935 15.6392 4.35935 14.391C3.85522 14.5018 3.37476 14.6094 2.89322 14.7122C1.62993 14.9817 0.51352 14.0972 0.505449 12.8108C0.497917 11.6083 0.498455 10.4052 0.505449 9.20274C0.512982 7.91309 1.62455 7.02803 2.88838 7.29704C3.37583 7.40088 3.86221 7.5101 4.37226 7.62201C4.37226 6.3641 4.37226 5.12825 4.37226 3.8741C5.62695 3.8741 6.86226 3.8741 8.12017 3.8741C8.0045 3.35006 7.88774 2.85023 7.7839 2.34772C7.53802 1.15329 8.40909 0.0282726 9.61535 0.0105176C10.8749 -0.00777538 12.1349 0.00190914 13.3945 0.00890351C13.8303 0.0115937 14.2252 0.161704 14.5561 0.445783C15.2028 1.00157 15.3803 1.70477 15.1861 2.52096C15.0812 2.96322 14.987 3.40763 14.8821 3.87626C16.1465 3.87626 17.3813 3.87626 18.6354 3.87626C18.6354 5.13148 18.6354 6.36679 18.6354 7.62147C19.1525 7.50741 19.6464 7.39443 20.1419 7.28951C21.0318 7.1012 21.9018 7.51387 22.2951 8.31876C22.3844 8.50169 22.4328 8.70506 22.5001 8.89929C22.5001 10.303 22.5001 11.7067 22.5001 13.1104C22.4861 13.1497 22.4683 13.1879 22.4586 13.2277C22.2725 13.9982 21.7979 14.4894 21.035 14.7046C20.6041 14.8262 20.186 14.7374 19.7663 14.6395C19.3956 14.5534 19.0233 14.4743 18.6252 14.3867C18.6252 15.6564 18.6252 16.8906 18.6252 18.1432C17.371 18.1432 16.1373 18.1432 14.8853 18.1432C14.9994 18.6591 15.1124 19.153 15.2168 19.648C15.4045 20.5363 14.9913 21.4069 14.187 21.7996C14.0041 21.8895 13.8007 21.9379 13.607 22.0051ZM10.8496 1.29748C10.4267 1.29748 10.0264 1.28457 9.62773 1.30125C9.26671 1.31631 8.9794 1.63321 9.04074 1.98239C9.15104 2.6135 9.30114 3.23815 9.4335 3.85904C9.92042 3.85904 10.3815 3.85904 10.8501 3.85904C10.8496 3.00357 10.8496 2.1621 10.8496 1.29748ZM21.2056 10.3563C21.2056 9.92531 21.2239 9.51103 21.2002 9.09944C21.1792 8.74165 20.8521 8.49846 20.4921 8.54312C20.3157 8.56518 20.1413 8.60768 19.967 8.64642C19.5237 8.74488 19.0809 8.84603 18.651 8.94287C18.651 9.43087 18.651 9.89196 18.651 10.3563C19.5038 10.3563 20.3399 10.3563 21.2056 10.3563ZM13.5683 3.86496C13.7011 3.24784 13.8443 2.6361 13.9605 2.01898C14.0229 1.68594 13.8055 1.3529 13.4757 1.32223C13.0399 1.28188 12.5976 1.31255 12.164 1.31255C12.164 2.17124 12.164 3.0181 12.164 3.86496C12.6375 3.86496 13.0942 3.86496 13.5683 3.86496ZM4.36365 8.93803C3.74115 8.8046 3.12404 8.65772 2.49992 8.54527C2.17065 8.48609 1.84084 8.72336 1.81447 9.0494C1.7795 9.47983 1.80587 9.91455 1.80587 10.3444C2.66779 10.3444 3.51411 10.3444 4.36365 10.3444C4.36365 9.87205 4.36365 9.41526 4.36365 8.93803ZM1.79672 11.6599C1.79672 12.0801 1.78112 12.4869 1.80156 12.892C1.81985 13.26 2.14805 13.5172 2.51553 13.465C2.77647 13.4279 3.03365 13.3628 3.2919 13.3063C3.6513 13.2272 4.00963 13.1443 4.36043 13.0653C4.36043 12.581 4.36043 12.1259 4.36043 11.6599C3.50819 11.6599 2.66671 11.6599 1.79672 11.6599ZM21.2083 11.6648C20.3383 11.6648 19.4919 11.6648 18.6402 11.6648C18.6402 12.1361 18.6402 12.5929 18.6402 13.0728C19.2681 13.2068 19.8922 13.3569 20.5234 13.4672C20.8709 13.528 21.1889 13.2401 21.2045 12.8796C21.2212 12.4804 21.2083 12.0801 21.2083 11.6648ZM10.8426 20.7128C10.8426 19.8428 10.8426 18.9965 10.8426 18.1442C10.3713 18.1442 9.91504 18.1442 9.44157 18.1442C9.31836 18.6957 9.19462 19.2445 9.07302 19.7944C9.0558 19.8708 9.04074 19.9488 9.03482 20.0268C9.00846 20.3808 9.26725 20.694 9.62773 20.709C10.0269 20.7257 10.4272 20.7128 10.8426 20.7128ZM12.1554 20.7139C12.5724 20.7139 12.9657 20.7241 13.3579 20.7106C13.7205 20.6983 14.0229 20.3905 13.9648 20.0462C13.8572 19.4081 13.7038 18.7775 13.5715 18.1523C13.0813 18.1523 12.6197 18.1523 12.1554 18.1523C12.1554 19.0083 12.1554 19.8503 12.1554 20.7139Z"
    //       className={styles.svgIconPath}
    //     />
    //   </svg>
  );
};

const EditAtendeeModal = ({ Attendee, setIsAtendee, onAtendeeSave }) => {
  const AttendeeDetail = useSelector(
    (state) => state.EventPlanningReducer.AttendeeDetail
  );

  return (
    <Modal
      isModalOpen={Attendee}
      setIsModalOpen={setIsAtendee}
      closable={true}
      // pinkBg={true}
      onClose={() => {
        setIsAtendee(false);
      }}
      className={styles.modal}
    >
      <div className={styles.modalDiv}>
        <TextComponent
          text={"Edit Attendees"}
          textClass={styles.modalHeading}
        />
        <div className={styles.inputs}>
          <InputField
            label={"Name"}
            value={Attendee?.name}
            onChange={(e) => {
              setIsAtendee({ ...Attendee, name: e.target.value });
            }}
            placeholder={"5"}
          />
          <DropDown
            label={"Meal"}
            placeholder={"Select Meal"}
            selectedValue={Attendee.meal}
            stylesClass={styles.dropdown}
            object={AttendeeDetail?.meals}
            onChange={(value) => {
              setIsAtendee({ ...Attendee, meal: value.val, meal_id: value.id });
            }}
          />
        </div>
        <SubmitButton
          title={"Update attendee"}
          btnClass={styles.modalBtn}
          onClick={onAtendeeSave}
        />
      </div>
    </Modal>
  );
};

const AttendeesDetails = () => {
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);

  const AttendeeDetail = useSelector(
    (state) => state.EventPlanningReducer.AttendeeDetail
  );
  const SeatingArrangement = useSelector(
    (state) => state.EventPlanningReducer.Seating
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAtendee, setIsAtendee] = useState(false);
  const [tableName, setTableName] = useState("");
  const [seats, setSeats] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log("tableNAme", tableName);

  const item = useLocation().state.item;

  useEffect(() => {
    dispatch(
      EventPlanningMiddleware.eventAttendeeDetail({
        event_id: EventDetails?.id,
        user_id: item?.id,
      })
    );
    dispatch(
      EventPlanningMiddleware.eventTables({ id: EventDetails?.id, name: "" })
    );
  }, []);

  const renderItem = (item, index) => {
    return (
      <div className={styles.listItem} key={item.id}>
        <div>
          <HiOutlineUser className={styles.listIcon} />
        </div>
        <div className={styles.listContent}>
          <TextComponent text={item?.name} textClass={styles.listname} />
          <div className={styles.mealDiv}>
            <TextComponent text={"Meal: "} textClass={styles.mealText} />
            <TextComponent text={item?.meal} textClass={styles.mealName} />
          </div>
        </div>

        <div className={styles.AT_nameDiv} style={{ justifyContent: "center" }}>
          <TextComponent
            text={"Edit"}
            textClass={styles.AT_edit}
            onClick={() => setIsAtendee(item)}
          />
        </div>
      </div>
    );
  };

  const renderTidbits = (item, index) => {
    return (
      <div className={styles.tbListItem} key={index}>
        <div className={styles.tbQuesDiv}>
          <GoDotFill className={styles.tbdot} />
          <TextComponent text={item?.question} textClass={styles.tbQues} />
        </div>
        {item?.answer && (
          <TextComponent text={item?.answer} textClass={styles.tbAns} />
        )}
      </div>
    );
  };

  console.log(tableName);
  const onSaveTable = () => {
    if (!tableName.id || seats <= 0) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Please select table and enter no of seats",
        })
      );
    } else {
      dispatch(
        EventPlanningMiddleware.assignTable({
          attendeeDetails: AttendeeDetail,
          seats,
          table: tableName,
          event_id: EventDetails?.id,
        })
      );
      setIsModalOpen(false);
    }
  };

  const onAtendeeSave = () => {
    if (!isAtendee.name) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Please enter name",
        })
      );
    } else {
      dispatch(EventPlanningMiddleware.updateAttendee(isAtendee)).then(() => {
        setIsAtendee(false);
      });
    }
  };

  console.log(
    "SeatingArrangement?.tables?.tables",
    SeatingArrangement?.tables?.tables
  );
  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <Box boxClass={styles.leftSubCont}>
          <TextComponent
            text={AttendeeDetail?.name}
            textClass={styles.attName}
          />
          <TextComponent text={"Personal info"} textClass={styles.attInfo} />
          <div className={styles.personalInfo}>
            <div className={styles.PI_head}>
              <MdCall className={styles.infoIcon} />
              <TextComponent text={"Contact:"} textClass={styles.infoheading} />
            </div>
            <TextComponent
              text={AttendeeDetail?.contact_no}
              textClass={styles.infoText}
            />
          </div>
          <div className={styles.personalInfo}>
            <div className={styles.PI_head}>
              <MdChat className={styles.infoIcon} />
              <TextComponent text={"Email:"} textClass={styles.infoheading} />
            </div>

            <TextComponent
              text={AttendeeDetail?.email}
              textClass={styles.infoText}
            />
          </div>
          <div className={styles.personalInfo}>
            <div className={styles.PI_head}>
              <LocIcon className={styles.infoIcon} size={15} />
              <TextComponent text={"Address:"} textClass={styles.infoheading} />
            </div>
            <TextComponent
              text={AttendeeDetail?.address}
              textClass={styles.infoText}
            />
          </div>
        </Box>
        <Box boxClass={styles.leftSubCont}>
          <TextComponent
            text={"Attendees and meal:"}
            textClass={styles.attheading2}
          />
          <List
            dataSource={
              AttendeeDetail?.attendees?.length > 0
                ? AttendeeDetail?.attendees
                : []
            }
            className={styles.list}
            renderItem={renderItem}
          />
          {!AttendeeDetail?.table_name ? (
            <div
              className={styles.assignedBtn}
              onClick={() => setIsModalOpen(true)}
            >
              <TableIcon />
              <TextComponent
                text={"Assign table"}
                textClass={styles.assignedBtnText}
              />
            </div>
          ) : (
            <div className={styles.assignedTableDiv}>
              <div className={styles.AT_head}>
                <TableIcon />
                <TextComponent
                  text={"Assigned Table"}
                  textClass={styles.AT_Text}
                />
              </div>
              <div className={styles.AT_nameDiv}>
                <TextComponent
                  text={AttendeeDetail?.table_name}
                  textClass={styles.AT_name}
                />
                <TextComponent
                  text={"edit"}
                  textClass={styles.AT_edit}
                  onClick={() => setIsModalOpen(true)}
                />
              </div>
            </div>
          )}
        </Box>
      </div>
      <Box boxClass={styles.rightCont}>
        <TextComponent text={"Tidbits"} textClass={styles.attheading2} />
        <List
          dataSource={
            AttendeeDetail?.tidbits?.length > 0 ? AttendeeDetail?.tidbits : []
          }
          renderItem={renderTidbits}
          className={styles.tbList}
        />
      </Box>
      {isModalOpen && (
        <Modal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          closable={true}
          // pinkBg={true}
          onClose={() => {
            setSeats(null);
            setTableName(null);
          }}
          className={styles.modal}
        >
          <div className={styles.modalDiv}>
            <TextComponent
              text={"Assign Table"}
              textClass={styles.modalHeading}
            />
            <div className={styles.inputs}>
              <DropDown
                label={"Table Name"}
                placeholder={"Head Table"}
                selectedValue={
                  AttendeeDetail?.table_name ? AttendeeDetail?.table_name : null
                }
                stylesClass={styles.dropdown}
                object={SeatingArrangement?.tables?.tables}
                onChange={(value) => {
                  setTableName(value);
                }}
              />
              <InputField
                label={"Seats"}
                value={seats}
                onChange={(e) => setSeats(e.target.value)}
                placeholder={"5"}
              />
            </div>
            <SubmitButton
              title={"Assign Table"}
              btnClass={styles.modalBtn}
              onClick={onSaveTable}
            />
          </div>
        </Modal>
      )}
      {isAtendee && (
        <EditAtendeeModal
          Attendee={isAtendee}
          setIsAtendee={setIsAtendee}
          onAtendeeSave={onAtendeeSave}
        />
      )}
    </div>
  );
};

export default AttendeesDetails;
